import React, { useState } from 'react'
import Share from '../../../../media/images/share.svg'
import ShareModal from '../../widgets/components/ShareModal'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../_metronic/partials'
import ImageCarousel from '../../founder-market/components/Carousel'
import { DisplayImage } from '../../widgets/components/General/DisplayImage'
import BlueImage from '../images/blue-bg.png'
import ConnectWithCofounderModal from './ConnectWithCofounderModal'
import brandingConfig from '../../../../config/brandingConfig'


const CofounderDetails = () => {
    const { mode } = useThemeMode()
    const { formatMessage } = useIntl()
    const charLimit = 100 // Adjust the limit as needed
    // const navigate = useNavigate()

    // Splitting the text based on the character limit
    const [isExpandedDescription, setIsExpandedDescription] = useState(false)

    // Splitting the text based on the character limit
    const description = 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam laudantium sit rerum ipsam incidunt porro tenetur fugit maxime ullam necessitatibus laborum natus assumenda consequatur odio, sint dolorum dolores nam blanditiis';
    const firstPartDescription = description.substr(0, charLimit) || '';
    const secondPartDescription = description.substr(charLimit) || '';

    const [isActive, setIsActive] = useState(false)
    const [isModalActive, setIsModalActive] = useState(false)
    const [urlToShare, setUrlToShare] = useState('')
    const handleModal = (url: any) => {
        setIsActive(() => !isActive)
        setUrlToShare(url)
        setIsActive(true)
    }

    const tags = [
        '#Business',
        '#MSWord',
        '#agreement',
        '#document',
        '#artist',
        '#producer',
        '#influencer',
    ];
    const images = [
        BlueImage,
        BlueImage,
        BlueImage,
        BlueImage,
        BlueImage,
    ];
    return (
        <>
            <div className='row'>
                <div className='col-md-6 h-fc'>
                    <ImageCarousel images={images} />
                </div>

                <div className='resourcesDetails col-md-6 h-fc'>
                    <div className='d-flex justify-content-between'>
                        <div className={`px-4 py-2 category` + (mode === `dark` ? `-dark` : ``)}>
                            Technology
                        </div>
                        <div className='d-flex align-items-center'>
                            <button
                                className='btn m-0 p-0 d-block'
                                onClick={() => handleModal(window.location.href)}
                            >
                                <img
                                    src={Share}
                                    alt='share'
                                    className='share align-self-center'
                                    style={{ height: '24px', width: '24px', marginRight: '14px' }}
                                />
                            </button>
                        </div>
                    </div>
                    {isActive && (
                        <ShareModal isActive={isActive} setIsActive={setIsActive} url={urlToShare} />
                    )}
                    <div className='ResourcesTitle d-flex justify-content-between align-items-center mt-2 mb-4'>
                        <h1 className='font-size-20'>We Are Looking For Dedicated Co-Founder</h1>
                    </div>

                    <div className='my-4'>
                        <h3 className='mb-4 font-size-16'>{formatMessage({ id: 'Requirements' })}</h3>
                        <div className='d-flex'>
                            <div className='w-50'>
                                <p>Role Title</p>
                            </div>
                            <div className='w-50'>
                                <p>Co-Founder & CMO</p>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='w-50'>
                                <p>Years of Experience</p>
                            </div>
                            <div className='w-50'>
                                <p>5 Years</p>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='w-50'>
                                <p>Equity Offering</p>
                            </div>
                            <div className='w-50'>
                                <p>Based On Performance</p>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='w-50'>
                                <p>Commitment level</p>
                            </div>
                            <div className='w-50'>
                                <p>Commitment level</p>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='w-50'>
                                <p>Fundraising Experiance</p>
                            </div>
                            <div className='w-50'>
                                <p>Yes</p>
                            </div>
                        </div>
                        <div className='d-flex'>
                            <div className='w-50'>
                                <p>Language Proficiency</p>
                            </div>
                            <div className='w-50'>
                                <p>English, French, Hindi</p>
                            </div>
                        </div>
                    </div>

                    <div className='my-4'>
                        <h3 className='mb-4 font-size-16'>{formatMessage({ id: 'Co-Founder Description' })}</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequa.</p>
                    </div>

                    <div className='my-4'>
                        <h3 className='mb-4 font-size-16'>{formatMessage({ id: 'Responsibility' })}</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequa.</p>
                        <ul>
                            <li>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut ali</li>
                            <li>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut ali</li>
                            <li>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut ali</li>
                            <li>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut ali</li>
                            <li>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut ali</li>
                        </ul>
                    </div>

                    <div className='p-2' style={{ background: "#4776E60A " }}>
                        <div className='my-4'>
                            <h3 className='font-size-14'>{formatMessage({ id: brandingConfig.brandName })}</h3>
                            <p>Fundraising Process Made Easy</p>
                        </div>
                        <div className='my-4'>
                            <h3 className='font-size-14'>{formatMessage({ id: 'Company Description' })}</h3>
                            <p>
                                {firstPartDescription}
                                {secondPartDescription && isExpandedDescription && <span>{secondPartDescription}</span>}&nbsp;
                                {secondPartDescription && (
                                    <button className='readmore' onClick={() => setIsExpandedDescription(!isExpandedDescription)}>
                                        {isExpandedDescription
                                            ? formatMessage({ id: 'Show Less' })
                                            : formatMessage({ id: 'Read More' })}
                                    </button>
                                )}
                            </p>
                        </div>
                        <div className='my-4'>
                            <h3 className='font-size-14'>{formatMessage({ id: 'Founders' })}</h3>
                            <div className='d-flex flex-wrap gap-4'>
                                {Array.from({ length: 3 }, (_, index) => (
                                    <div className='d-flex' key={index}>
                                        <DisplayImage className='rounded-circle' height={32} width={32} imgName='' alt='profile-pic' />
                                        <div className='me-4'>
                                            <p className='font-size-12 fw-semibold text-dark m-0'>Toshendra Sharma</p>
                                            <p className='font-size-12 text-muted m-0'>Founder & CEO</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className='resourcesTags my-4'>
                            {tags.map((tag, index) => (
                                <p className='tag' key={index}>
                                    {tag}
                                </p>
                            ))}
                        </div>
                    </div>
                    <div className='my-4 d-flex align-items-center gap-4'>
                        <button
                            className='btn btn-primary d-flex align-items-center w-100 w-md-auto d-flex justify-content-center'
                            onClick={() => setIsModalActive(true)}>
                            <p className='m-0'>{formatMessage({ id: 'Connect' })}</p>
                            <i className="fa-solid fa-up-right-from-square ps-2"></i>
                        </button>
                    </div>
                    {isModalActive && <ConnectWithCofounderModal isModalActive={isModalActive} setIsModalActive={setIsModalActive} />}
                </div>
            </div>

        </>
    )
}

export default CofounderDetails
